module.exports = __webpack_public_path__ + "static/media/csv_en.d682cb76.pdf";